
import Vue from "vue";
import { DcmConfigService } from "@/@modules/fseg/services/DcmConfigService";
import FsegLayout from "@/@modules/fseg/components/Layout.vue";
import SignatureList from "@/@modules/fseg/components/SignatureList.vue";

export default Vue.extend({
  components: {
    FsegLayout,
    SignatureList,
  },
  data() {
    return {
      config: DcmConfigService.getWorkerConfigForSignatureList(this),
    };
  },
});
